import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Home from './pages/Home';
import About from './pages/About';

function App() {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem('portfolio-language');
      if (stored === 'en' || stored === 'pt-BR') {
        setLanguage(stored);
      }
    } catch (e) {
      // Ignore storage errors
    }
  }, []);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    try {
      window.localStorage.setItem('portfolio-language', lang);
    } catch (e) {
      // Ignore storage errors
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className="vt323-regular App-logo">
          <span className="logo-arrow">&lt;</span>
          <span className="logo-text">farias</span>
          <span className="logo-suffix">.dev</span>
          <span className="logo-arrow">&gt;</span>
        </div>
      </header>

      <Router>
        <Routes>
          <Route
            path="/about"
            element={
              <About
                language={language}
                onLanguageChange={handleLanguageChange}
              />
            }
          />
          <Route
            path="/"
            element={
              <Home
                language={language}
                onLanguageChange={handleLanguageChange}
              />
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
